/**
 * User Redux state shape
 */

import type { FieldErrors } from '@/types/shared/form.types';

import type { User, Notification } from './User';

const NO_NOTIFICATIONS = 0;

export interface UserState {
  user: User | null;
  fieldErrors: FieldErrors;
  loadingUser: boolean;
  loadingNotifications: boolean;
  notifications: Notification;
}

export const initialUserState: UserState = {
  user: null,
  fieldErrors: {},
  loadingUser: false,
  loadingNotifications: false,
  notifications: { count: NO_NOTIFICATIONS, items: [] },
};
